import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack, Typography } from '@mui/material';
import AddFileIcon from 'icons/AddFileIcon';

const FileUploadOverlay = styled('div')<{ height: string }>`
  height: ${({ height }) => height};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  background: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 22px;
  opacity: 0;
  transition: opacity 0.4ms ease-in;

  &[data-active='true'] {
    z-index: 3;
    opacity: 1;
  }
`;

export const IconWrapper = styled('div')<{ position: [number, number] }>`
  position: relative;
  background: ${({ theme }) => theme.palette.grey[200]};
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  color: #6f6f6f;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  &[data-active='true'] {
    color: ${({ theme }) => theme.palette.primary.main};
    animation: pulse 1s infinite;
  }

  > svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: ${({ position }) =>
      `translate(-${position[0]}%, -${position[1]}%)`};
  }
`;

const TextBackground = styled.div`
  background: ${({ theme }) => theme.palette.primary.main};
  border-radius: 150px;
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
`;

type Props = {
  active: boolean;
  height: string;
};

const FileUploadIndicator = ({ active, height }: Props) => {
  const theme = useTheme();

  return (
    <FileUploadOverlay height={height} data-active={active}>
      <Stack
        sx={{
          alignItems: 'center',
        }}
      >
        {active && (
          <>
            <IconWrapper data-active={active} position={[55, 55]}>
              <AddFileIcon />
            </IconWrapper>
            <TextBackground>
              <Typography
                sx={{
                  color: active ? 'white' : theme.palette.grey[700],
                  fontSize: 16,
                  fontWeight: 700,
                }}
              >
                Drop file(s) to upload
              </Typography>
            </TextBackground>
          </>
        )}
      </Stack>
    </FileUploadOverlay>
  );
};

export default FileUploadIndicator;
